

export function parsePriceNumber(numero, locale = 'es-AR', decimales = 2) {
  if (numero === null || numero === undefined) return null;

  const strValue = String(numero);
  let valor;

  if (strValue.includes(',')) {
    valor = parseFloat(strValue.replace(',', '.'));
  } else {
    valor = parseFloat(strValue);
  }

  if (isNaN(valor)) return '-';

  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales
  });

  return formatter.format(valor);
}

export default parsePriceNumber;